import { render, staticRenderFns } from "./WasteDealForm.vue?vue&type=template&id=05b021ce&"
import script from "./WasteDealForm.vue?vue&type=script&lang=js&"
export * from "./WasteDealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports